import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconClose, IconPhone } from '@travel-frontend/icons';
import { isWithinInterval } from 'date-fns';
import { useTranslation } from 'next-i18next';
import { Control } from '../../../../components/HeaderNew/components/Control.js';
import { Body } from '../../../../components/HotlineBarNew/components/Information/components/Body.js';
import { Container } from '../../../../components/HotlineBarNew/components/Information/components/Container.js';
import { Content } from '../../../../components/HotlineBarNew/components/Information/components/Content.js';
import { Heading } from '../../../../components/HotlineBarNew/components/Information/components/Heading.js';
import { OpeningHoursAlert } from '../../../../components/HotlineBarNew/components/Information/components/OpeningHoursAlert/index.js';
import { Phone } from '../../../../components/internal/Phone.js';
import { LabelXSmall, ParagraphMedium } from '../../../../primitives/index.js';
import { useDirectusImageUrl } from '../../../../utils/directus.js';
import { HEADER_QA_ID, qaId } from '../../../../utils/qaId.js';
export const Information = ({
  phone,
  openingHours,
  onClose,
  specials,
  teaserImage,
  headline,
  subHeadline,
  ...restProps
}) => {
  const {
    t
  } = useTranslation();
  const specialItem = specials?.find(item => isWithinInterval(new Date(), {
    start: new Date(item.publishDate),
    end: new Date(item.expiryDate)
  }));
  return _jsxs(Container, {
    ...restProps,
    children: [_jsxs(Content, {
      children: [_jsx("img", {
        src: useDirectusImageUrl(teaserImage?.url),
        alt: ""
      }), _jsxs(Body, {
        "data-cy": qaId(HEADER_QA_ID, 'hotline', 'body', 'content'),
        "data-testid": qaId(HEADER_QA_ID, 'hotline', 'body', 'content'),
        children: [_jsx(Heading, {
          children: headline
        }), _jsx(ParagraphMedium, {
          color: "contentSecondary",
          children: subHeadline
        }), _jsxs(Phone, {
          href: `tel:${phone}`,
          "data-cy": qaId(HEADER_QA_ID, 'hotline', 'number'),
          "data-testid": qaId(HEADER_QA_ID, 'hotline', 'number'),
          children: [_jsx(IconPhone, {}), " ", phone]
        }), _jsx(LabelXSmall, {
          color: "contentSecondary",
          children: t('headerNew:hotline.workingHours', {
            openingHours
          })
        })]
      }), specialItem && _jsx(OpeningHoursAlert, {
        headline: headline,
        specials: specialItem?.items
      })]
    }), _jsx(Control, {
      onClick: onClose,
      "data-cy": qaId(HEADER_QA_ID, 'hotline', 'close', 'button'),
      "data-testid": qaId(HEADER_QA_ID, 'hotline', 'close', 'button'),
      children: _jsx(IconClose, {})
    })]
  });
};